module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('audio', {
    attrs: {
      "src": _vm.playurl,
      "id": "audio"
    },
    on: {
      "timeupdate": _vm.playingtime,
      "error": _vm.errormp3,
      "waiting": _vm.waiting,
      "ended": _vm.next_music,
      "canplay": function($event) {
        _vm.setplaying(true)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-loader/11.3.4/vue-loader/lib/template-compiler?{"id":"data-v-993893e4"}!./~/.npminstall/vue-loader/11.3.4/vue-loader/lib/selector.js?type=template&index=0!./src/components/music.vue
// module id = 117
// module chunks = 27